import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AdminUserService } from 'src/app/services/admin-user.service';
import { DssValidators } from 'src/app/services/dss.validators';

@Component({
  selector: 'app-admin-changepassword',
  templateUrl: './admin-changepassword.component.html',
  styleUrls: ['./admin-changepassword.component.scss']
})
export class AdminChangepasswordComponent implements OnInit {

  updateResult: any = null;
  private unsubscribe: Subject<any> = new Subject();

  pwInputTypeCurrent: string = 'password';
  pwInputTypeNew: string = 'password';
  pwInputTypeConfirm: string = 'password';

  pwdForm: FormGroup;
  constructor(private fb: FormBuilder, private userService: AdminUserService, private router: Router) { 
    this.pwdForm = this.fb.group({
      'currentpassword': ['', Validators.required],
      'newpassword': ['', [
        Validators.required,
        Validators.minLength(8),
        DssValidators.hasDigit,
        DssValidators.hasLowerCase,
        DssValidators.hasUpperCase,
        DssValidators.hasNonAlphaNumeric,
        ]
      ],
      'confirmpassword': ['', [
        Validators.required,
        ]
      ]
    })
  }

  ngOnInit() {
  }

  update() {
    if (this.updateHasErrors()) {
      return;
    }

    this.updateResult = this.userService.updatePassword(this.pwdForm.value);
    if (this.updateResult.success)
    {
      this.updateResult.failureMessage = '';
    }
    this.pwdForm.reset();
    this.router.navigate(["/admin-changepassword"]);
  }

  updateHasErrors() {
    var cp = this.currentpassword;
    if (!!cp.errors && (cp.errors.required)) { return true; }
    var np = this.newpassword;
    if (!!np.errors && ( 
        np.errors.required ||
        np.errors.minlength ||
        np.errors.hasDigit ||
        np.errors.hasLowerCase ||
        np.errors.hasUpperCase ||
        np.errors.hasNonAlphaNumeric)) { return true; }

    var cfp = this.confirmpassword;
    if (!!cfp.errors && (cfp.errors.required || cfp.value !== np.value)) { return true; }

    return false;
  }

  get currentpassword() {
    return this.pwdForm.get('currentpassword')
  }

  get newpassword() {
    return this.pwdForm.get('newpassword')
  }

  get confirmpassword() {
    return this.pwdForm.get('confirmpassword')
  }

  showCurrentPwdToggle() {
    if (this.pwInputTypeCurrent === "password") {
      this.pwInputTypeCurrent = "text";
    } else {
      this.pwInputTypeCurrent = "password";
    }
  }

  showNewPwdToggle() {
    if (this.pwInputTypeNew === "password") {
      this.pwInputTypeNew = "text";
    } else {
      this.pwInputTypeNew = "password";
    }
  }

  showConfirmPwdToggle() {
    if (this.pwInputTypeConfirm === "password") {
      this.pwInputTypeConfirm = "text";
    } else {
      this.pwInputTypeConfirm = "password";
    }
  }

  disableUpdateButton() {
    if (this.currentpassword.errors == null && this.newpassword.errors == null && this.confirmpassword.errors == null && this.confirmpassword.value == this.newpassword.value ) {
      return false;
    } else {
      return true;
    }
  }

}
